<template>
  <div class="rental-income">
    <div class="operating">
      <div class="number-count">
        <div class="title">入库单</div>
          <el-upload
            :disabled="loading2 ? true : false"
            v-loading.fullscreen.lock="loading2"
            element-loading-text="文件上传中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            class="upload"
            ref="upload"
            action="#"
            :show-file-list="false"
            :auto-upload="true"
            :before-upload="warehousingEntryExcel"
          >
            <el-button slot="trigger" class="btn-blue"
              >导入</el-button
            >
          </el-upload>
      </div>
      <div class="date-calculate">
        <div class="title">历史库存表</div>
        <el-form label-width="20px" :model="ruleForm2" ref="ruleForm2">
          <el-form-item prop="warehouseId">
            <el-select
              class="white"
              clearable
              filterable
              v-model="ruleForm2.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="reportDate">
            <el-date-picker
              class="w200"
              v-model="ruleForm2.reportDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-upload
              :disabled="loading ? true : false"
              v-loading.fullscreen.lock="loading"
              element-loading-text="文件上传中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              class="upload"
              ref="upload"
              action="#"
              :show-file-list="false"
              :auto-upload="true"
              :before-upload="stockExcel"
            >
              <el-button slot="trigger" class="btn-blue"
                >导入</el-button
              >
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <div v-if="evenList.length > 0 || oddList.length > 0" class="main">
          <div class="container left">
            <div :class="item.count !== 0?'row':'active row'" v-for="(item,index) in oddList" :key="index">
              <span>{{ item.oddExportName }}</span>
              <span>{{ item.date }}</span>
            </div>
          </div>
          <div class="container">
            <div :class="item.count !== 0?'row':'active row'" v-for="(item,index) in evenList" :key="index">
              <span>{{ item.evenExportName }}</span>
              <span>{{ item.date }}</span>
            </div>
          </div>
        </div>
        <div class="nothing" v-else>
          <div class="img">
            <img src="../../../../assets/images/export-nothing.png" />
          </div>
        </div>
      </div>
      <div class="rental-costs">
        <div class="title">场租费用重算</div>
        <el-form label-width="20px" :model="ruleForm3" ref="ruleForm3">
          <el-form-item prop="warehouseId">
            <el-select
              class="white"
              clearable
              filterable
              v-model="ruleForm3.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item prop="reportDate">
            <el-date-picker
              class="w200"
              v-model="ruleForm3.reportDate"
              value-format="yyyy-MM"
              type="month"
              placeholder="选择月份"
            ></el-date-picker>
          </el-form-item> -->
          <el-form-item>
            <el-button
              class="btn-blue"
              @click="calculate('ruleForm3')"
            >
              计算
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import RentalIncome from "models/rental-income";
const rentalIncome = new RentalIncome();
import Expenses from "models/expenses";
const expenses = new Expenses();
export default {
  data() {
    return {
      loading: false,
      loading2: false,
      warehouseList: [],
      evenList: [],
      oddList: [],
      ruleForm2: {
        warehouseId: "",
        reportDate: ""
      },
      ruleForm3: {
        warehouseId: "",
        // reportDate: ""
      },
    };
  },
  watch: {
    ruleForm2: {
      handler() {
        if (this.ruleForm2.warehouseId && this.ruleForm2.reportDate) {
          this.initStockRecord()
        }
      },
      deep: true,
      immediate: true,
    }
  },
  created() {
    this.getWarehouse()
  },
  methods: {
    //获取仓库数据
    getWarehouse() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },
    //入库单导入
    warehousingEntryExcel(file) {
      var formData = new FormData();
      formData.append("file", file);
      this.loading2 = true;
      rentalIncome
        .postWarehousingEntryExcel(formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
            this.loading2 = false;
          } else {
            this.loading2 = false;
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(res => {
          this.loading2 = false;
          this.$message.error("导入失败");
        });
      return false;
    },
    //库存表导入
    stockExcel(file) {
      if (!this.ruleForm2.warehouseId) {
        this.$message.error('请选择仓库')
        return
      }
      if (!this.ruleForm2.reportDate) {
        this.$message.error('请选择日期')
        return
      }
      var formData = new FormData();
      formData.append("file", file);
      formData.append("warehouseId", this.ruleForm2.warehouseId);
      formData.append("date", this.ruleForm2.reportDate);
      this.loading = true;
      rentalIncome
        .postStockExcel(formData)
        .then(res => {
          if (res.success) {
            this.loading = false;
            this.$message.success("导入成功");
          } else {
            this.loading = false;
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(res => {
          this.loading = false;
          this.$message.error("导入失败");
        });
      return false;
    },
    //计算
    calculate() {
      if (!this.ruleForm3.warehouseId) {
        this.$message.error('请选择仓库')
        return
      }
      // if (!this.ruleForm3.reportDate) {
      //   this.$message.error('请选择月份')
      //   return
      // }
      let warehouseId = this.ruleForm3.warehouseId
      // let month = this.ruleForm3.reportDate
      rentalIncome.getCalculationRentalCosts(warehouseId).then(res => {
        if (res.success) {
          this.$message.success('计算成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    initStockRecord() {
      let warehouseId = this.ruleForm2.warehouseId
      let date = this.ruleForm2.reportDate
      rentalIncome.getStockRecord(warehouseId, date).then(res => {
        if (res.success) {
          let evenArr = []
          let oddArr = []
          res.result.map(i => {
            let reportDate = Number(i.date.split('-')[2])
            if (reportDate%2===0) {
              let obj = {}
              obj.count = i.count
              if (i.count) {
                obj.evenExportName = '库存表_导入成功'
              } else {
                obj.evenExportName = '库存表_未导入'
              }
              obj.date = i.date
              evenArr.push(obj)
            } else {
              let obj2 = {}
              obj2.id = i.id
              obj2.count = i.count
              if (i.count) {
                obj2.oddExportName = '库存表_导入成功'
              } else {
                obj2.oddExportName = '库存表_未导入'
              }
              obj2.date = i.date
              oddArr.push(obj2)
            }
          })
          oddArr.sort(this.sortNumber)
          evenArr.sort(this.sortNumber)
          this.oddList = oddArr
          this.evenList = evenArr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 历史库存表多条件排序
    sortNumber(a, b){
      if (a.count & b.count) {
        return this.getDate(a.date) > this.getDate(b.date) ? -1 : 1
      } else {
        return a.count < b.count ? -1 : 1
      }
    },
    // 日期转为时间戳
    getDate(v) {
      let date = new Date(v)
      return date.getTime()
    }
  }
};
</script>
<style lang="scss" scoped>
.rental-income {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  .operating {
    flex: 1;
    padding-top: 32px;
    border-radius: 4px;
    padding-bottom: 32px;
    .title {
      color: #333;
      font-size: 16px;
      line-height: 32px;
    }
    .w200 {
      width: 200px;
    }
    .number-count,
    .date-calculate,
    .rental-costs {
      width: 800px;
      height: 72px;
      box-sizing: border-box;
      background: #F8F9FA;
      border-radius: 6px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 19px;
    }
    .number-count {
      margin-bottom: 24px;
    }
    .rental-costs {
      margin-top: 24px;
    }
    .table {
      background: #F8F9FA;
      padding: 0px 20px 20px;
      .main {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        background: #fff;
        height: 300px;
        overflow-y: auto;
        .left {
          position: relative;
          &::before {
            content: '';
            position: absolute;
            top: 10px;
            right: 0%;
            width: 1px;
            height: 280px;
            background: #eee;
          }
        }
        .container {
          width: 50%;
          .row {
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 13px 30px 13px 20px;
            font-size: 14px;
            color: #333;
          }
          .active {
            color: #F56C6C;
          }
        }
      }
    }
    .el-form {
      display: flex;
      justify-content: center;
      align-items: center;
      .el-form-item {
        margin-bottom: 0;
      }
      .el-select {
        width: 200px;
      }
    }
    .nothing {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 300px;
      background: #fff;
      .img {
        width: 160px;
        height: 128px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
